// Footer / contact section — company name, address, opening hours, phone,
// and email, all read from the settings table via GET /public/company
// (hooks/useCompanyInfo.js). Editing any of these on the admin settings
// screen changes what shows here; nothing is hardcoded.
//
// id="contact" is SiteHeader.jsx's own "Contact" nav anchor target — this
// component and that header are only ever rendered together on the same
// page (see PortalShell.jsx / LandingPage.jsx).
//
// Each field renders only when it has a value: an unconfigured company
// (every settings key still empty) shows just the heading rather than blank
// or placeholder lines — the same "never present fabricated contact data as
// real" stance this component was written with, now backed by real data
// when it exists.

import { useLanguage } from '../context/LanguageContext.jsx';
import { useCompanyInfo } from '../hooks/useCompanyInfo.js';
import styles from './SiteFooter.module.css';

export default function SiteFooter() {
  const { t } = useLanguage();
  const company = useCompanyInfo();

  return (
    <footer id="contact" className={styles.footer}>
      <p className={styles.title}>{t('portal.footer.contactTitle')}</p>

      {company.name && <p className={styles.line}>{company.name}</p>}
      {company.address && <p className={styles.line}>{company.address}</p>}
      {company.openingHours && <p className={styles.line}>{company.openingHours}</p>}
      {company.phone && (
        <p className={styles.line}>
          <a className={styles.contactLink} href={`tel:${company.phone.replace(/\s+/g, '')}`}>
            {company.phone}
          </a>
        </p>
      )}
      {company.email && (
        <p className={styles.line}>
          <a className={styles.contactLink} href={`mailto:${company.email}`}>
            {company.email}
          </a>
        </p>
      )}
    </footer>
  );
}
